import { Stack } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IRootTemplateProps } from '~/components/templates/RootTemplate';
import { RootTemplate } from '~/components/templates/RootTemplate';

export type IPageTemplateProps = IRootTemplateProps;

const styles = stylex.create({
  content: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: 688,
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingTop: '7rem',
    paddingBottom: '7rem',
  },
});

export const PageTemplate: React.FC<IPageTemplateProps> = (props) => {
  const { children, ...other } = props;

  return (
    <RootTemplate {...other}>
      <Stack gap={6} sx={styles.content}>
        {children}
      </Stack>
    </RootTemplate>
  );
};
